export default __webpack_public_path__ + "static/media/Carrusel_Arrow_left.52e88975.svg";